// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5200) return "static/chunks/5200-d0d257547835b570.js";
	if (chunkId === 18) return "static/chunks/18-ba8b15b252b0d636.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"238":"fbb433caa05602a5","1779":"59cb0b01b5bd7493","2268":"880800d911de2492","3655":"556d828b10638e80","3877":"917d0aa49566e39a","4104":"c7b9cccc711983da","6530":"d9642fea1cf709e7","7397":"0bb4f73bb35d6f5e","9025":"895944a655d64c12","9550":"ac90c88c1a0b2c36"}[chunkId] + ".js";
};